"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleOrderLabFormToPayloadDataHandler = exports.labRequisitionTemplate = void 0;
const formToPayloadDataHandler_1 = require("./formToPayloadDataHandler");
const initialData_1 = __importDefault(require("./initialData"));
const payloadToFormDataHandler_1 = require("./payloadToFormDataHandler");
const schema_1 = __importDefault(require("./schema"));
const uiSchema_1 = __importDefault(require("./uiSchema"));
const labRequisitionTemplate = (labs) => {
    const allLabOptions = labs.map(l => ({
        const: l.id,
        title: l.labName,
    }));
    return {
        schema: (0, schema_1.default)(allLabOptions),
        uiSchema: uiSchema_1.default,
        initialData: initialData_1.default,
        formToPayloadDataHandler: (0, formToPayloadDataHandler_1.scheduleOrderLabFormToPayloadDataHandler)(labs, []),
        payloadToFormDataHandler: payloadToFormDataHandler_1.scheduleLabRequisitionPayloadToFormDataHandler,
        middleware: (state, action, defaultReducer) => {
            const core = defaultReducer(state, action);
            if (core.errors && core.errors.length > 0) {
                core.errors = core.errors.map(e => {
                    if (e.message &&
                        [
                            "must have required property 'labId'",
                            "must have required property 'icdCode'",
                            "must have required property 'labTest'",
                            "must have required property 'phoneNumber'",
                            "must have required property 'countryCode'",
                            "must have required property 'requisitionType'",
                            "must have required property 'collectionFrequency'",
                        ].includes(e.message)) {
                        return Object.assign(Object.assign({}, e), { message: "is a required property" });
                    }
                    else if (e.message && e.keyword === "uniqueItems") {
                        return Object.assign(Object.assign({}, e), { message: "duplicates not allowed" });
                    }
                    else if (e.message && e.keyword === "type") {
                        return Object.assign(Object.assign({}, e), { message: "invalid date" });
                    }
                    return e;
                });
            }
            return core;
        },
    };
};
exports.labRequisitionTemplate = labRequisitionTemplate;
var formToPayloadDataHandler_2 = require("./formToPayloadDataHandler");
Object.defineProperty(exports, "scheduleOrderLabFormToPayloadDataHandler", { enumerable: true, get: function () { return formToPayloadDataHandler_2.scheduleOrderLabFormToPayloadDataHandler; } });
